import React, { useContext } from 'react'
import { LawyersContext } from './index'

const { lawyersData } = window

const LawyerList = () => {
	const { openDetailed } = useContext(LawyersContext)
	return (
		<ul className="lawyer-list">
			{Object.keys(lawyersData).map(key => {
				const { ID, avatar, name, title } = lawyersData[key]
				return (
					<li
						className="lawyer-item"
						key={key}
						onClick={() => openDetailed(key)}
					>
						<img src={avatar} alt={name} />
						<div className="lawyer-info">
							<h3 className="lawyer-name">{name}</h3>
							<p className="lawyer-title">{title}</p>
						</div>
					</li>
				)
			})}
		</ul>
	)
}

export default LawyerList
